module.exports = [{"type":"hash","text":"接入方式"},{"type":"normal","text":"實盘行情Websocket的接入URL：wss://open-api-swap.bingx.com/swap-market"},{"type":"normal","text":"模擬盘行情Websocket的接入URL：wss://vst-open-api-ws.bingx.com/swap-market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/introduce/01_connect.json
// module id = uUP9
// module chunks = 3